import React from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { Building, Leaf } from "lucide-react";

function RoleSelectionModal({ onSelect, onClose }) {
  return createPortal(
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-[9999]">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ type: "spring", damping: 20, stiffness: 300 }}
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md border border-gray-100"
      >
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Select Your Role</h2>
          <p className="text-gray-600 mt-2">Choose how you want to use the app.</p>
        </div>

        <div className="p-6 space-y-4">

          {/* Admin */}
          <motion.div
            whileHover={{ y: -5, scale: 1.01 }}
            className="p-6 rounded-xl border-2 border-gray-200 hover:border-indigo-400 hover:shadow-md cursor-pointer"
            onClick={() => onSelect("admin")}
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-indigo-100 rounded-lg text-indigo-600">
                <Building className="h-5 w-5" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-800">Dairy Owner</h3>
                <p className="text-gray-600 text-sm mt-1">
                  I own or manage a dairy farm.
                </p>
              </div>
            </div>
          </motion.div>

          {/* User */}
          <motion.div
            whileHover={{ y: -5, scale: 1.01 }}
            className="p-6 rounded-xl border-2 border-gray-200 hover:border-indigo-400 hover:shadow-md cursor-pointer"
            onClick={() => onSelect("user")}
          >
            <div className="flex items-start gap-4">
              <div className="p-3 bg-indigo-100 rounded-lg text-indigo-600">
                <Leaf className="h-5 w-5" />
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-800">Milk Supplier</h3>
                <p className="text-gray-600 text-sm mt-1">
                  I supply milk to dairies and want to track payments.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="p-6 border-t border-gray-200 flex justify-end">
          <button
            className="px-6 py-2 text-gray-700 rounded-lg font-medium hover:bg-gray-100"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </motion.div>
    </div>,
    document.body
  );
}

export default RoleSelectionModal;
